import {
	createSVGMarkerObject,
	getMarkerIcon,
} from '@aspendental/shared-components-web/lib/components/GoogleMap/StandardGoogleMap/StandardGoogleMap.helpers';
import { NearbyFacility } from '@aspendental/shared-components-web/lib/graphql/__generated/sdk';
import { generateFacilityUrl } from '@aspendental/shared-components-web/lib/utils/generateFacilityUrl';
import {
	APIProvider,
	Map,
	AdvancedMarker,
	RenderingType,
	MapCameraChangedEvent,
	MapCameraProps,
} from '@vis.gl/react-google-maps';
import Image from 'next/image';
import { useState, useCallback, useEffect } from 'react';

import { getGoogleMapStyles } from './ProviderGoogleMap.styles';

export default function ProviderGoogleMap({
	facilitiesArr,
	currentFacilityLat,
	currentFacilityLon,
	handleMarkerClick,
	isMobileScreen,
	googleMapId,
	googleMapApiKey,
}) {
	const [cameraProps, setCameraProps] = useState<MapCameraProps>({
		zoom: 10,
		center: { lat: currentFacilityLat, lng: currentFacilityLon },
	});
	const handleCameraChange = useCallback((event: MapCameraChangedEvent) => setCameraProps(event.detail), []);

	useEffect(() => {
		setCameraProps({
			zoom: 10,
			center: { lat: currentFacilityLat, lng: currentFacilityLon },
		});
	}, [currentFacilityLat, currentFacilityLon]);
	return (
		<APIProvider apiKey={googleMapApiKey}>
			<Map
				{...cameraProps}
				onCameraChanged={handleCameraChange}
				style={getGoogleMapStyles(isMobileScreen)}
				mapId={googleMapId}
				renderingType={RenderingType.VECTOR}
			>
				{(facilitiesArr as unknown as NearbyFacility[]).map(({ facility }, index: number) => {
					const { brand, name, location } = facility;
					const facilityUrl = generateFacilityUrl(location?.stateCode, location?.city, location?.address1);
					const isSelectedLocation =
						facility.location?.latitude === currentFacilityLat &&
						facility.location?.longitude === currentFacilityLon;
					return (
						<AdvancedMarker
							key={`${name}-${index}`}
							title={name}
							position={{
								lat: facility?.location?.latitude,
								lng: facility?.location?.longitude,
							}}
							clickable={true}
							onClick={() => handleMarkerClick(facilityUrl)}
						>
							<Image
								src={createSVGMarkerObject(getMarkerIcon(brand, isSelectedLocation))}
								alt=""
								width={64}
								height={64}
							/>
						</AdvancedMarker>
					);
				})}
			</Map>
		</APIProvider>
	);
}
